






import Vue from 'vue';

export default Vue.extend({
  name: "GameShowMain2d",
  data: () => {
    return {};
  },
});
